export default __webpack_public_path__ + "static/media/347C6BA8-AEC0-4AC5-AF1C-5FC21DA45F97.6e25a11c.jpeg";